import { Spin, Table, Space, Button } from 'antd';
import { Tabs } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  updateComment,
  statuses,
  statusActionItems,
  actionItemsToStatus
} from '../../../../services/commentsService';

import './CommentsTable.scss';
const { TabPane } = Tabs;

const CommentsTable = ({
  data,
  current,
  totalCount,
  onPaginationChange,
  fetching,
  offset,
  fetchComments,
  setSelectedTab
}) => {
  const [columnsState, setColumnsState] = useState([]);
  const [dataWithStatus, setDataWithStats] = useState({
    pending: data.filter((item) => item.status === 'pending')
  });

  const handleStatusUpdate = async (comment, updatedStatus) => {
    await updateComment({
      comment,
      status: updatedStatus
    })
      .then((response) => {
        fetchComments();
      })
      .catch((error) => {
        alert('Updating comment failed!');
      });
  };
  const renderActions = (comment) => {
    return (
      <Space>
        {statusActionItems[comment.status].map((actionItem) => {
          return (
            <Button
              onClick={() =>
                handleStatusUpdate(
                  comment,
                  actionItemsToStatus[actionItem]
                )
              }>
              {`${actionItem}`}
            </Button>
          );
        })}
      </Space>
    );
  };

  useEffect(() => {
    let columnsCollection = [
      {
        dataIndex: 'index',
        key: 'index',
        width: 20,
        render: (value, record, index) => {
          const label = <span>{offset + index + 1}</span>;
          return label;
        }
      },
      {
        title: 'Name',
        dataIndex: 'fullName',
        key: 'fullName',
        width: 100,
        render: (value, record) => {
          return (
            <span>{`${record?.learner?.firstName} ${record?.learner?.lastName}`}</span>
          );
        }
      },
      {
        title: 'user id',
        dataIndex: 'userId',
        key: 'userId',
        width: 100,
        render: (value, comment) => {
          return <span>{comment?.userId}</span>;
        }
      },
      {
        title: 'Course Code',
        dataIndex: 'courseCode',
        key: 'courseCode',
        width: 100,
        render: (value, comment) => {
          return <span>{comment?.courseCode}</span>;
        }
      },
      {
        title: 'Video',
        dataIndex: 'video',
        key: 'video',
        width: 100,
        render: (value, comment) => {
          return <span>{comment?.subunit?.title}</span>;
        }
      },
      {
        title: 'Comment',
        dataIndex: 'comment',
        key: 'comment',
        width: 300,
        render: (value, comment) => {
          return <span>{comment?.text}</span>;
        }
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (value, comment) => {
          return <span>{comment?.status}</span>;
        }
      },
      {
        title: 'Replying to',
        dataIndex: 'replyTo',
        key: 'replyTo',
        width: 300,
        render: (value, comment) => {
          return <span>{comment?.replyTo?.text ?? '----'}</span>;
        }
      },
      {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        width: 100,
        render: (value, comment) => {
          return renderActions(comment);
        }
      }
    ];
    setColumnsState(columnsCollection);
    setDataWithStats({
      all: data,
      pending: data.filter((item) => item.status === 'pending'),
      deleted: data.filter((item) => item.status === 'deleted'),
      approved: data.filter((item) => item.status === 'approved'),
      rejected: data.filter((item) => item.status === 'rejected')
    });
  }, [data]);

  const renderTab = (status, index) => {
    return (
      <TabPane tab={`${status}`} key={`${index}`}>
        <div>
          {fetching ? <Spin /> : null}
          {data.length > 0 ? (
            <div>
              <div>Total count: {dataWithStatus[status].length}</div>
              <Table
                rowClassName={(record, index) => record?.status}
                columns={columnsState}
                bordered
                tableLayout="auto"
                bordered
                size="middle"
                scroll={{ x: 'calc(700px + 50%)' }}
                dataSource={dataWithStatus[status]}
                expandable={{ defaultExpandAllRows: true }}
                pagination={{
                  current,
                  total: totalCount,
                  defaultPageSize: 20,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '20', '30']
                }}
                onChange={onPaginationChange}
              />
            </div>
          ) : null}
          {data.length === 0 && !fetching ? (
            <div>No record found</div>
          ) : null}
        </div>
      </TabPane>
    );
  };

  return (
    <Tabs
      defaultActiveKey="1"
      type="card"
      size="middle"
      className="Tabs-component-demo"
      onChange={(e) => {
        setSelectedTab(e === 0 ? {} : statuses[e]);
        fetchComments();
      }}>
      <>
        {statuses.map((status, index) => {
          return renderTab(status, index);
        })}
      </>
    </Tabs>
  );
};

export default CommentsTable;
